<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset scrollable>
    <div style="position:relative!important;overflow:auto;">
      <v-sheet>
        <v-btn
          style="z-index:20; position:absolute; top:0; right:0;"
          @click="
            () => {
              this['Product/fetchProducts']({ page: this.page });
              $router.push('/product');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card class="elevation-0">
          <v-window v-model="windows" vertical>
            <v-window-item value="details">
              <v-list>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Product Name</v-list-item-title>
                    <v-list-item-subtitle>{{ product.name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Product Price</v-list-item-title>
                    <v-list-item-subtitle>{{
                      product.price.toLocaleString()
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Product Description</v-list-item-title>
                    <v-list-item-subtitle>{{ product.description }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Supplier</v-list-item-title>
                    <v-list-item-subtitle>{{
                      product.supplier_id == null ? '' : product.supplier.company_name
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Supplier Code</v-list-item-title>
                    <v-list-item-subtitle>{{
                      product.supplier_id == null ? '' : product.supplier.supplier_code
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Product Type</v-list-item-title>
                    <!--<v-list-item-subtitle>{{ product.product_type.name }}</v-list-item-subtitle>-->
                    <v-list-item-subtitle>{{
                      product.product_type_id == null ? '' : product.product_type.name
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Attachments</v-list-item-title>
                    <v-dialog width="500" v-for="image in product.files" :key="image.id">
                      <template v-slot:activator="{ on }">
                        <v-img
                          :src="'/attachement/' + image.path"
                          max-height="50px"
                          max-width="50px"
                          v-on="on"
                        />
                      </template>
                      <v-img
                        :src="'/attachement/' + image.path"
                        max-height="500px"
                        max-width="500px"
                      />
                    </v-dialog>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Karat</v-list-item-title>
                    <v-list-item-subtitle>{{ product.karat }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Item Weight</v-list-item-title>
                    <v-list-item-subtitle>{{ product.item_weight }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Rate/Gram</v-list-item-title>
                    <v-list-item-subtitle>{{ product.rate_gram }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Measurement</v-list-item-title>
                    <v-list-item-subtitle>{{ product.measurement }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Classification of Gold</v-list-item-title>
                    <v-list-item-subtitle>{{ product.gold_classification }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>No. Of Diamonds</v-list-item-title>
                    <v-list-item-subtitle>{{ product.no_of_diamond }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Specification</v-list-item-title>
                    <v-list-item-subtitle>
                      <ul v-for="specification in product.meta">
                        <li>{{ specification['specName'] + ' : ' + specification['value'] }}</li>
                      </ul>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-window-item>
            <v-window-item value="inventory">
              <productshowinventory
                :checkbox="chipFilter == 'instock'"
                :inventories="inventories"
              />
            </v-window-item>
            <v-window-item value="addinventory">
              <productshowaddinventory v-on:added="windows = 'inventory'" />
            </v-window-item>
          </v-window>
          <v-card-actions>
            <v-chip class="mx-2" :disabled="windows === 'details'" @click="windows = 'details'">
              Details
            </v-chip>
            <v-chip class="mx-2" :disabled="windows === 'inventory'" @click="windows = 'inventory'">
              Inventory
            </v-chip>
            <span v-if="windows == 'inventory'">
              <v-chip
                class="mx-2"
                filter
                :input-value="chipFilter == 'instock'"
                @click="setChipFilter('instock')"
              >
                In stock({{ inStockCount }})
              </v-chip>
              <v-chip
                class="mx-2"
                filter
                :input-value="chipFilter == 'sold'"
                @click="setChipFilter('sold')"
              >
                Sold({{ soldCount }})
              </v-chip>
            </span>
            <v-spacer></v-spacer>
            <v-btn
              v-if="windows == 'inventory' && product.classification != 'Customized'"
              outlined
              color="green"
              :disabled="windows === 'addinventory'"
              @click="windows = 'addinventory'"
            >
              Add inventory
            </v-btn>
            <v-btn @click="deleteProduct" outlined color="red">
              Delete
            </v-btn>
            <v-btn @click="goToEdit" color="indigo" outlined>
              Edit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </div>
    <confirm ref="confirm"></confirm>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import productshowinventory from './ProductShowInventory';
import productshowaddinventory from './ProductShowAddInventory';
import confirm from '../../components/Confirm.vue';

export default {
  data: function() {
    return {
      windows: 'details',
      chipFilter: 'instock'
    };
  },
  components: {
    productshowinventory,
    productshowaddinventory,
    confirm
  },
  props: {
    show: false,
    page: 0
  },
  beforeMount() {
    if (this.show) {
      this['Product/getProduct']({ id: this.$route.params.id }).finally(() => {
        if (this.product.name == '') {
          this.$router.push('/product');
        }
      });
    }
  },
  mounted() {
    if (this.show) {
      this['Product/getProduct']({ id: this.$route.params.id });
    }
  },
  computed: {
    inStockCount() {
      let count = 0;
      this.product.inventories.forEach(item => {
        if (item.sale_id == null) {
          count += 1;
        }
      });
      return count;
    },
    soldCount() {
      let count = 0;
      this.product.inventories.forEach(item => {
        if (item.sale_id != null) {
          count += 1;
        }
      });
      return count;
    },
    ...mapState({
      product(state) {
        if (typeof state.Product.product.data == 'undefined') {
          return {
            name: '',
            price: '',
            description: '',
            supplier: {
              company_name: '',
              supplier_code: ''
            },
            product_type: {
              name: ''
            },
            files: '',
            karat: '',
            item_weight: '',
            rate_gram: '',
            measurement: '',
            gold_classification: '',
            no_of_diamond: '',
            meta: [],
            inventories: [],
            classification: ''
          };
        } else {
          return {
            name: state.Product.product.data.name,
            price: state.Product.product.data.price,
            description: state.Product.product.data.description,
            supplier: state.Product.product.data.supplier,
            product_type: state.Product.product.data.product_type,
            files: state.Product.product.data.files,
            karat: state.Product.product.data.karat,
            item_weight: state.Product.product.data.item_weight,
            rate_gram: state.Product.product.data.rate_gram,
            measurement: state.Product.product.data.measurement,
            gold_classification: state.Product.product.data.gold_classification,
            no_of_diamond: state.Product.product.data.no_of_diamond,
            meta: JSON.parse(state.Product.product.data.meta),
            inventories: state.Product.product.data.inventories,
            classification: state.Product.product.data.classification
          };
        }
      }
    }),
    inventories: function() {
      let inventory = [];
      this.product.inventories.forEach(item => {
        if (this.chipFilter == 'instock' && item.sale_id == null) {
          inventory.push(item);
        } else if (this.chipFilter == 'sold' && item.sale_id != null) {
          inventory.push(item);
        }
      });
      // return this.product.inventories;
      return inventory;
    }
  },
  methods: {
    ...mapActions(['Product/fetchProducts', 'Product/getProduct']),
    setChipFilter(filter) {
      this.chipFilter = filter;
    },
    deleteProduct() {
      this.$refs.confirm
        .open(
          'Delete Product',
          'Are you sure you want to delete product ' + this.product.name + '?',
          { color: '#f44336' }
        )
        .then(confirm => {
          axios
            .delete(`api/v1/product/${this.$route.params.id}`)
            .then(response => {
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Product deleted...',
                color: 'success'
              });
              this['Product/fetchProducts']({ page: this.page });
              this.$router.push('/product');
            })
            .catch(error => {
              if (error.response.status == 403) {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              } else {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data.errors['id'][0],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {});
        });
    },
    goToEdit() {
      this.$router.push(`/product/${this.$route.params.id}/edit`);
    }
  }
};
</script>
